import {Toaster} from '@gravity-ui/uikit';

export const toaster = new Toaster();
